import React from "react";

class ExplicitOptIn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isMoreOpen: false
        };
    }

    handleClick = (event) => {
        const { isMoreOpen } = this.state;
        event.preventDefault();
        this.setState({
            isMoreOpen: !isMoreOpen
        });
    };

    render() {
        const { dataQa, labels, handleInputChange, data, domain } = this.props;
        const { isMoreOpen } = this.state;
        const {
            form_privacy1,
            form_privacy2,
            form_privacyUrl,
            from_privacy3,
            form_privacyemail,
            form_privacy4,
            form_updateagreement1,
            form_updateagreement2,
            form_updateagreement3
        } = labels;
        // handle window being undefined on gatsby build
        if (domain !== ".com") {
            const moreText = (
                <div className="gdpr__moreInfo">
                    {form_privacy1}
                    &nbsp;
                    <a href={form_privacyUrl} target="_blank" rel="noopener noreferrer">
                        {form_privacy2}
                    </a>
                    {from_privacy3}
                    &nbsp;
                    <a href={`mailto:${form_privacyemail}`}>{form_privacyemail}</a>
                    {form_privacy4}
                </div>
            );
            const inputStyle = {
                width: "auto",
                height: "auto",
                margin: "auto 6px auto auto",
                border: "unset",
                display: "inline-block"
            };
            return (
                <div className="gdpr__container">
                    <label data-qa={`${dataQa}-label`} htmlFor="ExplicitOptIn" className="gdpr__label">
                        <input
                            data-qa={dataQa}
                            onChange={handleInputChange}
                            value={data}
                            id="ExplicitOptIn"
                            name="ExplicitOptIn"
                            className="gdpr_checkbox"
                            type="checkbox"
                            autoComplete="off"
                            style={inputStyle}
                        />
                        {form_updateagreement1}
                        &nbsp;
                        <button type="button" onClick={this.handleClick}>
                            {form_updateagreement2}
                        </button>
                        &nbsp;
                        {form_updateagreement3}
                    </label>
                    {isMoreOpen && moreText}
                </div>
            );
        }
        return null;
    }
}

export default ExplicitOptIn;
